/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const CheckCircleOutlineUnchecked = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 67.6 66" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M33.9 1.5C16.1 1.5 1.6 15.9 1.6 33.7S16.1 66 33.9 66s32.2-14.4 32.2-32.2S51.7 1.5 33.9 1.5zm0 59.4c-15 0-27.2-12.2-27.2-27.2S18.9 6.5 33.9 6.5 61 18.7 61 33.7 48.9 60.9 33.9 60.9z" />
      </g>
    </svg>
  </span>
);

CheckCircleOutlineUnchecked.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

CheckCircleOutlineUnchecked.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default CheckCircleOutlineUnchecked;
